<script setup lang="ts">
import { useDeviceBatteryInformation } from './utils/useDeviceBatteryInformation';
import { BatteryInformationDto } from '@/api/generator';
import { computed } from 'vue';

const props = defineProps<{
  value?: BatteryInformationDto | null;
}>();

const info = useDeviceBatteryInformation(computed(() => props.value));
</script>

<template>
  <div v-if="info" class="device-battery-state d-flex align-center">
    <v-sheet
      color="surface"
      class="icon-wrapper d-inline-flex justify-center align-center"
      rounded="sm"
    >
      <v-icon :color="info.color" size="22"> {{ info.icon }}</v-icon>
    </v-sheet>
    <div v-if="info.capacity === 'poweradapter'">
      {{ $t('PowerAdapter') }}
    </div>
    <div v-else-if="info.capacity">
      {{
        $t('BatteryRemaining', {
          capacity: info.capacity,
          remainingDuration: info.remainingDuration,
        })
      }}
    </div>
    <div v-else>
      {{ $t('NoBatteryData') }}
    </div>
  </div>
</template>

<style lang="scss" scoped>
.device-battery-state {
  padding: 2px;
  gap: 4px;
  .icon-wrapper {
    width: 22px;
    height: 22px;
  }
}
</style>
